import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { defineCustomElement } from "linescale-components/dist/components/ls-linescale";
import type { Widget_d } from "core-lib";

defineCustomElement();

@Component({
  selector: 'linescale-wrapper',
  standalone: true,
  imports: [],
  templateUrl: './linescale-wrapper.component.html',
  styleUrl: './linescale-wrapper.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LinescaleWrapperComponent {
  data = input.required<Widget_d>();
  scaleText = computed(() => this.data().scale_text?.slice().reverse() ?? []);
  tickMark = computed(() => {
    const data = this.data() as any;
    if (!data.value)
      return null;
    return { value: data.value as number, label: Math.trunc(data.scaled_value * 100) / 100 }
  });
  items = computed(() => {
    const data = this.data() as any;
    return data.items ?? [];
  });
}
